
    import {Options, Vue} from 'vue-property-decorator';
    import StepItemTitle from '@/profile-creation-wizard/common/ui/StepItemTitle.vue';
    import {SeniorityLevel} from '@/profile-creation-wizard/components/for-completion/domain/types';

    @Options({
        components: {
            StepItemTitle,
        },
    })
    export default class SeniorityLevelSelection extends Vue {
        seniorityLevels: SeniorityLevel[] = Object.values(SeniorityLevel);

        selectSeniorityLevel(customEvent: CustomEvent): void {
            if (customEvent.detail.checked) {
                this.$emit('seniority-level-selected', customEvent.detail.value);
            } else {
                this.$emit('seniority-level-unselected');
            }
        }

        seniorityLevelId(seniorityLevel: SeniorityLevel): string {
            return `profile-creation-seniority-level-${seniorityLevel.toLowerCase()}`;
        }
    }
